import {
  TOGGLE_BOTTOM_PALETTE,
  SET_CURRENT_TIME,
  TOGGLE_VIDEO_PAUSE,
  VIDEO_ENDED,
  SET_TIME_FOR_VIDEO_TO_PLAY,
  SET_VIDEO_DATA,
  ADD_VIDEO_DATA,
  QUIZ_ENDED,
  MODIFY_HELPER_REDUCER,
  GET_WEBSITE_INFO,
  GET_WEBSITE_INFO_SUCCEEDED,
  GET_WEBSITE_INFO_FAILED,
  CLEAR_HELPER_STATE,
  SET_HELPER_EDIT_DATA,
} from './index';

export const toggleBottomPalette = () => ({
    type: TOGGLE_BOTTOM_PALETTE
});

export const setCurrentTime = (value) => ({
    type: SET_CURRENT_TIME,
    payload: value
});

export const toggleVideoPause = () => ({
    type: TOGGLE_VIDEO_PAUSE
});
export const videoEnded = (status) => ({
    type: VIDEO_ENDED,
    payload: status
});

export const quizEnded = (status) => ({
    type: QUIZ_ENDED,
    payload: status
});

export const setTimeForVideoToPlay = (time) => ({
    type: SET_TIME_FOR_VIDEO_TO_PLAY,
    payload: time
});
export const setVideoData = (data = {}) => ({
    type: SET_VIDEO_DATA,
    payload: data,
});

export const addVideoData = (data = {}) => ({
    type: ADD_VIDEO_DATA,
    payload: data
});

export const modifyHelperReducerData = (payload) => {
    return {
        type: MODIFY_HELPER_REDUCER,
        payload
    }
}
export const setHelperEditData = (data = {}) => {
  return {
    type: SET_HELPER_EDIT_DATA,
    payload: {
      data,
    },
  };
};

export const getWebsiteInfo = ({ link }) => {
    return {
        type: GET_WEBSITE_INFO,
        payload: {
            url: `get-website-info/?link=${link}`,
            onSuccess: GET_WEBSITE_INFO_SUCCEEDED,
            onFailure: GET_WEBSITE_INFO_FAILED,
        }
    };
}

export const clearHelperState = () => {
    return {
        type: CLEAR_HELPER_STATE
    }
}
